export * from './app-tasks.component';



// WEBPACK FOOTER //
// ./src/app/components/app-tasks/index.ts